import React, { useEffect, useRef } from 'react'
import USTemplateDefault from 'src/components/template/us'
import { videos } from 'src/constants/videos'
import { leagueIds, sportIds } from 'src/constants/personalizationIds'
import FuboFreeTemplate from 'src/components/template/fubofree'
import { fanduelSportsNetworkFAQs } from 'src/constants/faqs'
import { usPlanData } from 'src/constants/planData/usPlanData'
import { useIsStandaloneAvailable } from 'src/modules/hooks/useIsStandaloneAvailable'
import { useSelector } from 'react-redux'
import { fireUIRenderEvent } from 'src/modules/analytics/v3'
import { selectStateForProtobuf } from 'src/modules/reducers'
import { RSNS_BY_SPORT_TYPE } from 'src/constants/planData'

export default (props) => {
  const { isAvailable, planData, teams, rsns } = useIsStandaloneAvailable({ sportType: 'nba' })
  const isEventSent = useRef(false)
  const stateForProtobuf = useSelector(selectStateForProtobuf)

  useEffect(() => {
    if (isAvailable && !isEventSent.current) {
      fireUIRenderEvent(
        {
          type: 'eligible',
          component: 'nba_rsns_is_eligible',
        },
        stateForProtobuf
      )
      isEventSent.current = true
    }
  }, [isAvailable])

  const commonProps = {
    location: props.location,
    lang: 'en',
    market: 'us',
    video: videos.nba.videoUrl,
    annotations: videos.nba.annotations,
    title: 'Watch NBA Games online with Fubo',
    subtitle: 'Catch live games, shows and highlights',
    league: 'nba',
    showRSN: true,
    matchtickerSportId: sportIds.Basketball,
    matchtickerLeagueName: 'NBA',
    matchtickerLeagueId: leagueIds.NBA,
    caRedirectUrl: '/ca/nba-tv-ca/',
    sportId: sportIds.Basketball,
    leagueId: leagueIds.NBA,
  }

  if (isAvailable) {
    return (
      <FuboFreeTemplate
        {...commonProps}
        hasPlanCards={true}
        plans={[
          {
            ...planData,
            promoImg:
              'https://assets-imgx.fubo.tv/marketing/lp/images/card/rsn_basketball_hockey_plan_card.jpg',
          },
          { ...usPlanData.pro_standalone_monthly, networkLogos: RSNS_BY_SPORT_TYPE.nba },
        ]}
        plansSharedData={{
          teams: teams,
        }}
        additionalFAQs={fanduelSportsNetworkFAQs}
        sportType="nba"
        customNetworks={props.customNetworks || [...rsns]}
        {...props}
      />
    )
  } else {
    return <USTemplateDefault {...commonProps} {...props} networkSet="basketball" />
  }
}
